import { TabStrip, TabStripSelectEventArguments } from '@progress/kendo-react-layout'
import React, { useEffect, useState } from 'react'
import Tab from '../../components/tab'
import { makeSideBarActive } from '../../utils/EllowUtils';
import SideMenu from '../sideMenu';
import DashboardHeader from '../topbar';
import Styles from "./styles.module.scss";
import * as CONSTANTS from '../../utils/CONSTANTS'
import Table from '../../components/table';
import { getCRresources } from './services';
import { getAPI } from '../../api/api';
import { REACT_APP_COMMON } from '../../utils/common';


function CRresources() {

    const name = localStorage.getItem('Name')
    const menu = makeSideBarActive(CONSTANTS.crSideMenu, 1)
    let BreadcrumsValues = ['CRResources']  
    const userloginId = localStorage.getItem("loginId");
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [filterValues, setFilterValues] = useState<any>(null);
    const [sort, setSort] = useState<any>();
    const [CRresourceData, setCRresourceData] = useState<any>([])
    const [CRresourceCount, setCRresourceCount] = useState<string>('')
    const [CRdraftResources, setCRdraftResources] = useState<any>()
    const [CRdraftCount, setCRdraftCount] = useState<string>('')
    const [skillList, setSkillList] = useState<any>()

    useEffect(() => {
      getCRresourcesData(1, 25, 'crowdSourcingAll', '', '', '')
      getCRresourcesData(1, 25, 'crowdSourcingDraft', '', '', '')
      getAPI( REACT_APP_COMMON + '/skills').then((resp: any) => {
        if (resp && resp.status === 1) {
          setSkillList(resp.data);
        }
      })
    }, [])
    
  
  const getCRresourcesData = (page: number, pageSize: number, tab: string, search: string, filter?: any, sort?: any) => {

    let value: any;
    if (filter) {
      filter.behalf_of = {id: userloginId, name: name }
      value = {
        filters: filter,
         sort : {
          sortBy: sort ? sort[0] && sort[0].field : "name",
          sortOrder: sort ? sort[0] && sort[0].dir :"ASC"
        }
      }
    }
    else {
      value = {filters: {
        behalf_of: {id: userloginId, name: name },
      },
      sort :{
        sortBy: sort ? sort[0] && sort[0].field : "name",
        sortOrder: sort ? sort[0] && sort[0].dir :"ASC"
        }
      }
    }  
    getCRresources(page, pageSize, tab, search, value).then((response: any) => {
      switch (tab) {
        case 'crowdSourcingAll':
          setCRresourceData(response.data)
          setCRresourceCount(response.count)
          break;
        case 'crowdSourcingDraft':
          setCRdraftResources(response.data)
          setCRdraftCount(response.count)
      }
    })
    
    }

  
    const searchChange = (search: any) => {
    getCRresourcesData(1, 25, 'crowdSourcingAll', search, '', '')
    getCRresourcesData(1, 25, 'crowdSourcingDraft', search, '', '')
    }
    
  const applyFilter = (data: any) => {      
      getCRresourcesData(1, 25, 'crowdSourcingAll', '', data, '')
      getCRresourcesData(1, 25, 'crowdSourcingDraft', '', data, '')
      delete data.behalf_of;
      setFilterValues(data)

    }
    
    const handleSelect = (e: TabStripSelectEventArguments) => {
        setSelectedTab(e.selected)       
    }
      
    const closeTag = (data: any) => {
      setFilterValues(data.filters)
      getCRresourcesData(1, 25, 'crowdSourcingAll', '', data, '')
      getCRresourcesData(1, 25, 'crowdSourcingDraft', '', data, '')
    }
    
    const AllTab = <>All resources <i>{CRresourceCount}</i></>
    const DraftTab = <>Draft <i>{CRdraftCount}</i></>
    
   const applySort = (data: any) => {
      getCRresourcesData(1, 25, 'crowdSourcingAll', '', '', data)
      getCRresourcesData(1, 25, 'crowdSourcingDraft', '', '', data)
   }


  return (
    <section className="dashboardWrapper">
    <SideMenu menu={menu} openresource={'allresources'} />
    <div className="dashboardContent">
      <DashboardHeader title={BreadcrumsValues}   navigateTo={'/CRcreateresources'} type='CRresources' searchChange={searchChange} applyCrResourceFilter={applyFilter} filterValues={filterValues} closeTag={closeTag} skillsList={skillList} />
      <div className={Styles.sourceFilter}>
      </div>
      <section className={Styles.dashboardWrapper}>
        <TabStrip selected={selectedTab} onSelect={handleSelect}>
            <Tab title={AllTab} >
              <Table
             setSort={setSort}
             applySort={applySort}
             data={CRresourceData}
          //      getTablesValues={getTables}
                type={"CRresources"}
          //      total={total}
          //      pageChange={pageChange}
          //      rowClick={onClick}
          //      pageSize={pageSize}
          //      draftKey={props.draftKey}
        //        hideStatus={props.hideStatus}
          //      hideSubmittedTo={props.hideSubmittedTo}
              />
            </Tab>
            <Tab title={DraftTab}>
            <Table
             setSort={setSort}
             applySort={applySort}
                data={CRdraftResources}
          //      getTablesValues={getTables}
                type={"CRresources"}
          //      total={total}
          //      pageChange={pageChange}
          //      rowClick={onClick}
          //      pageSize={pageSize}
          //      draftKey={props.draftKey}
        //        hideStatus={props.hideStatus}
          //      hideSubmittedTo={props.hideSubmittedTo}
              />
            </Tab>
        </TabStrip>
      </section>
    </div>
  </section>
  )
}

export default CRresources